import * as types from './actionTypes';  
import currentDateTimesApi from '../api/currentDateTimesApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function getCurrentDateTimeRes(data) {  
  return {
    type: types.FETCH_CURRENT_DATE_TIME_RES, 
    data
  };
}

export function getCurrentDateTime() {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      currentDateTimesApi.doFetchCurrentDateTime().then(data => {
        dispatch(getCurrentDateTimeRes(data));
        dispatch(getCurrentDateTimeRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}